export const SERVICE_FAILURE_DEFAULT_LABELS = {
  EXIT_WORKFLOW: 'Exit Workflow',
  RUN_SERVICE: 'Run Service',
  DO_NOT_RUN_SERVICE: 'Do Not Run Service',
};

export const SERVICE_FAILURE_DEFAULT_VALUES = {
  [SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW]: null,
  [SERVICE_FAILURE_DEFAULT_LABELS.RUN_SERVICE]: true,
  [SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_RUN_SERVICE]: false,
};

// Special Option Keys:
export const BASE_URL_OPTION_KEY = 'base_url';
export const CREDENTIAL_OWNER_OPTION_KEY = 'credential_owner';
export const CUSTOMER_LIST_ID_OPTION_KEY = 'customer_list_id';
export const DISPLAY_NAME_OPTION_KEY = 'service_node_display_name';
export const DISPLAY_NAME_OPTION_NAME = 'Service Node Display Name';
export const MODULES_OPTION_KEY = 'modules';
export const TAGS_OPTION_KEY = 'tags';
export const UPLOADED_RESPONSE_KEY = 'uploaded_response';
export const WEBHOOK_KEY = 'webhookHandlerApplicationId';

export const SERVICE_OPTION_TEXTFIELD_LABEL_MAP = new Map([
  [BASE_URL_OPTION_KEY, 'Base Url'],
  [MODULES_OPTION_KEY, 'Modules'],
]);

// Options to exclude from additional options section:
export const RESERVED_KEYS = [
  DISPLAY_NAME_OPTION_KEY,
  CUSTOMER_LIST_ID_OPTION_KEY,
  TAGS_OPTION_KEY,
];
